import Button from "../../../../designComponents/Button";
import Flex from "../../../../designComponents/Flex";
import { ReviewFieldNameType, ViewReviewType } from "../types";

type Props = {
  underReview: boolean;
  isAccepted: boolean;
  hasRecentReview: boolean;
  fieldKey: ReviewFieldNameType;
  hasPreviousReview: boolean;
  onViewReviews: (data: ViewReviewType) => void;
  setOpenReviewModal: (data: ReviewFieldNameType) => void;
};

const ReviewButtons = ({
  fieldKey,
  hasPreviousReview,
  hasRecentReview,
  isAccepted,
  onViewReviews,
  setOpenReviewModal,
  underReview,
}: Props) => {
  return (
    <Flex
      direction="row"
      wrap="wrap"
      gap={"20px"}
      justifyContent="space-between"
    >
      {underReview && !isAccepted && !hasRecentReview && (
        <Button
          variant="gray"
          bgColor="secondary"
          color="light.white"
          onClick={() => {
            if (fieldKey) {
              setOpenReviewModal(fieldKey);
            }
          }}
        >
          New Review
        </Button>
      )}
      {hasRecentReview && (
        <Button
          variant="gray"
          bgColor="colorActive"
          color="light.white"
          onClick={() => {
            onViewReviews("recent");
          }}
        >
          View Recent Review
        </Button>
      )}
      {hasPreviousReview && (
        <Button
          variant="gray"
          bgColor="highlight"
          color="light.white"
          onClick={() => {
            onViewReviews("previous");
          }}
        >
          View Previous Review
        </Button>
      )}
    </Flex>
  );
};

export default ReviewButtons;
